import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import text from '../../_constants/text'

const BillingGuideLookupDisclaimer: React.FC = () => {
  return (
    <Row className="no-gutters mb-4">
      <Col>
        <div className="card">
          <div className="card-body">
            <div className="richtext" dangerouslySetInnerHTML={{ __html: text.BILLING_GUIDE_DISCLAIMER }} />
          </div>
        </div>
      </Col>
    </Row>
  )
}

export default BillingGuideLookupDisclaimer
